import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Carousel from "react-material-ui-carousel";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { enqueueNotification } from "../../../redux/slice/notification/notificationSlice";
import { BannerConfig } from "../../../types/banner-config";
import { getTenantName } from "../../../util";
import { cn } from "../../../util/cn";

const Banners = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const [banners, setBanners] = useState<BannerConfig[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const tenantName = getTenantName();
  if (!tenantName) throw new Error("Tenant name is not defined");

  useEffect(() => {
    const loadImages = async () => {
      try {
        const module = await import(
          `../../../tenants/${tenantName}/assets/img/carouselImages/${i18n.language}/index.ts`
        );
        setBanners(module.default);
      } catch (error) {
        dispatch(
          enqueueNotification({
            severity: "error",
            message: `Failed to load banners, error: ${error}`, // Todo: add translation
          })
        );
      }
    };
    loadImages();
  }, [tenantName, i18n.language, dispatch]);

  const handleBannerChange = (now?: number) => {
    if (now !== undefined) {
      setCurrentIndex(now);
    }
  };

  if (banners.length === 0) return <></>;

  return (
    <div className="mx-0 mb-9 w-full aspect-[16/7] !px-0">
      <Carousel
        className="aspect-[14/5]"
        animation="slide"
        indicators={false}
        autoPlay={true}
        interval={5000}
        onChange={handleBannerChange}
        navButtonsProps={{
          style: {
            display: "none",
          },
        }}
      >
        {banners.map((banner, i) => (
          <Link key={i} to={banner.href}>
            <img
              className="object-cover w-full rounded-xl"
              src={banner.src}
              alt={`Banner ${i + 1}`}
            />
          </Link>
        ))}
      </Carousel>
      {/* Custom Indicator */}
      {banners.length > 1 && (
        <div
          className={`flex justify-center my-2.5 gap-1 w-[${
            50 * banners.length
          }px] mx-auto bg-background h-5 rounded-md`}
        >
          {banners.map((_, index) => (
            <div
              key={`indicator-${index}`}
              className={cn(
                "w-7 h-1 rounded-lg transition-colors",
                index === currentIndex ? "bg-foreground/70" : "bg-foreground/10"
              )}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Banners;
